import { Routes } from '@angular/router';
import { LoginGuard } from 'src/shared/guards/login.guard';

export const DemoRoutes: Routes = [
  {
    path: 'demo',
    canActivate: [LoginGuard],
    loadComponent: () => import('./pages/demo/demo.component').then((m) => m.DemoComponent),
  },
];
